import { ChartBrandingInfo } from '../../common/models/chart-branding-info';

export class Brand {
  constructor(
    public readonly name?: string,
    public readonly styleSheetName?: string,
    public chartInfo?: ChartBrandingInfo
  ) { }
}

